import {useQuery} from 'react-query'
import {GroupDiscountEditModalForm} from './GroupDiscountEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getGroupDiscountById} from '../core/_requests'

const GroupDiscountEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: groupdiscount,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-groupdiscount-${itemIdForUpdate}`,
    () => {
      return getGroupDiscountById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )
  if (!itemIdForUpdate) {
    return <GroupDiscountEditModalForm isGroupDiscountLoading={isLoading} groupdiscount={{id: undefined}} />
  }

  if (!isLoading && !error && groupdiscount) {
    console.log({groupdiscount, },"its groupdiscount")
    console.log(typeof groupdiscount,"its groupdiscount")
    return <GroupDiscountEditModalForm isGroupDiscountLoading={isLoading} groupdiscount={groupdiscount} />
  }

  return null
}

export {GroupDiscountEditModalFormWrapper}
